module.exports = __webpack_public_path__ + "img/greenwich.c5974ae7.jpg";